import React from "react";
import { useLottie } from "lottie-react";
import rbs from "../../assets/imgs/RBS-CTA.json";

const RbsLottie = () => {
  const options = {
    animationData: rbs,
    loop: true
  };

  const { View } = useLottie(options);

  return <>{View}</>;
};

export default RbsLottie;